// src/components/AssistantLauncher.tsx
//
// Global floating "Assistant" button (bottom-right) + slide-in drawer that
// hosts the conversational AI analyst. Replaces the old Assistant tab inside
// the Analytics hub so the assistant is reachable from every page. Gated by the
// same `analytics.assistant` feature as the old tab (opt-in per tenant, needs an
// Anthropic key on the agent) so it only appears where it's enabled.

import { useState } from 'react';
import { Sparkles, X } from 'lucide-react';
import { AssistantTab } from '../pages/analytics/AssistantTab';
import { useModuleAccess } from '../hooks/useModuleAccess';

export default function AssistantLauncher() {
  const { canAccess } = useModuleAccess();
  const [open, setOpen] = useState(false);

  if (!canAccess('analytics.assistant')) return null;

  return (
    <>
      {!open && (
        <button
          onClick={() => setOpen(true)}
          className="fixed bottom-5 right-5 z-40 flex items-center gap-2 rounded-full bg-blue-600 hover:bg-blue-500 text-white pl-4 pr-5 py-3 shadow-lg shadow-blue-900/40 transition-colors"
          title="Ask the AI analyst"
        >
          <Sparkles size={18} />
          <span className="text-sm font-medium hidden sm:inline">Assistant</span>
        </button>
      )}

      {open && (
        <div className="fixed inset-0 z-50 flex justify-end">
          <div className="absolute inset-0 bg-black/40" onClick={() => setOpen(false)} />
          <div className="relative w-full max-w-xl h-full bg-slate-950 border-l border-slate-700/60 shadow-2xl flex flex-col">
            <div className="flex items-center justify-between px-4 py-3 border-b border-slate-700/50 shrink-0">
              <div className="flex items-center gap-2 text-white font-semibold">
                <Sparkles size={18} className="text-blue-400" /> Assistant
              </div>
              <button
                onClick={() => setOpen(false)}
                className="p-2 rounded-lg text-slate-400 hover:text-white hover:bg-slate-800/60 transition-colors"
                title="Close"
              >
                <X size={18} />
              </button>
            </div>
            <div className="flex-1 overflow-auto">
              <AssistantTab />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
